import React, { useEffect } from 'react';

/**
 * AdSense Component - Placeholder for Google AdSense Ads
 * 
 * To integrate real Google AdSense:
 * 1. Sign up for Google AdSense and get your publisher ID
 * 2. Replace 'ca-pub-XXXXXXXXXXXXXXXX' with your actual publisher ID
 * 3. Add the AdSense script to public/index.html:
 *    <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-XXXXXXXXXXXXXXXX" crossorigin="anonymous"></script>
 */

const AdSense = ({ slot, format = 'auto', responsive = true, style = {} }) => {
  useEffect(() => {
    try {
      // Push ad to AdSense when component mounts
      if (window.adsbygoogle && process.env.NODE_ENV === 'production') {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (e) {
      console.error('AdSense error:', e);
    }
  }, []);

  // For development/preview - show placeholder
  if (process.env.NODE_ENV !== 'production') {
    return (
      <div 
        className="bg-gray-800/30 border border-gray-700 rounded-lg flex items-center justify-center p-8"
        style={{ minHeight: '250px', ...style }}
      >
        <div className="text-center">
          <div className="text-gray-500 text-sm mb-2">Advertisement</div>
          <div className="text-gray-600 text-xs">AdSense Placeholder - {format}</div>
        </div>
      </div>
    );
  }

  // Production AdSense code
  return (
    <ins
      className="adsbygoogle"
      style={{ display: 'block', ...style }}
      data-ad-client="ca-pub-4903133917234059"
      data-ad-slot={slot}
      data-ad-format={format}
      data-full-width-responsive={responsive ? 'true' : 'false'}
    />
  );
};

// Predefined ad sizes for common placements
export const AdSenseTypes = {
  BANNER: { format: 'horizontal', style: { minHeight: '90px' } },
  RECTANGLE: { format: 'rectangle', style: { minHeight: '250px' } },
  VERTICAL: { format: 'vertical', style: { minHeight: '600px' } },
  IN_ARTICLE: { format: 'fluid', style: { minHeight: '200px' } },
};

export default AdSense;